import * as React from 'react';

export type ProgressTimer = {
  elapsed: number;
  start: () => void;
  reset: () => void;
  pause: () => void;
};

type CircularProgressProps = {
  duration: number;
  onTime: () => void;
}

const CircularProgress = React.forwardRef<
  ProgressTimer,
  CircularProgressProps
>(({ duration, onTime }, ref) => {
  const onTimeRef = React.useRef<() => void>(onTime);
  const progressRef = React.useRef<SVGPathElement>(null);

  React.useEffect(() => {
    onTimeRef.current = onTime;
  }, [onTime]);

  React.useEffect(() => {
    let timerId: NodeJS.Timer;

    const timer = {
      elapsed: 0,
      isStarted: false,
      start: () => {
        if (timer.isStarted) {
          return;
        }

        timerId = setTimeout(tick, 10);
      },
      reset: () => {
        clearTimeout(timerId);
        timer.elapsed = 0;

        const progress = 0;
        const circumference = 2 * Math.PI * duration;
        const offset = circumference * (1 - progress);

        if (progressRef.current) {
          progressRef.current.style.strokeDashoffset = offset.toString();
        }

        if (timer.isStarted) {
          timerId = setTimeout(tick, 10);
        }
      },
      pause: () => {
        clearTimeout(timerId);
        timer.isStarted = false;
      },
    };

    const tick = () => {
      timer.elapsed += 0.01;

      const progress = timer.elapsed / duration;
      const circumference = 2 * Math.PI * duration;
      const offset = circumference * (1 - progress);

      if (progressRef.current) {
        progressRef.current.style.strokeDashoffset = offset.toString();
      }

      timerId = setTimeout(tick, 10);

      if (timer.elapsed >= duration && onTimeRef.current) {
        onTimeRef.current();
      }

      if (timer.elapsed >= duration) {
        timer.elapsed = 0;
      }
    };

    timer.start();

    if (ref && typeof ref === 'function') {
      ref(timer);
    } else if (ref && typeof ref === 'object') {
      ref.current = timer;
    }

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g strokeWidth="3" transform="translate(2 2)">
          <circle cx="10" cy="10" r="10" stroke="#E1E1E1" />
          <path
            ref={progressRef}
            stroke="#2C445A"
            strokeDasharray="63,80"
            style={{ strokeDashoffset: 63 }}
            d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z"
          />
        </g>
      </g>
    </svg>
  );
});

export default CircularProgress;



// WEBPACK FOOTER //
// ./src/components/CourseCarousel/CircularProgress.tsx